<div class="preloaded-content">
  <ng-content></ng-content>
</div>
<div class="preloader">
  <div class="spinner"></div>
</div>
